<div class="position-relative">
  <div (click)="onChatClick()" id="draggable-div"
    class="d-flex align-items-center img-radius justify-content-center wid-40 hei-40 
    p-2 bg-primary position-fixed cursor-pointer chat-main-icon">
    <i class="fa fa-solid fa-comments f-20 text-white"></i>
    <div class="wid-15 hei-15" [ngClass]="hasUnReadChat ? ' bg-danger position-absolute img-radius blink_message_indicator' : ''"></div>
  </div>
</div>